import type { Theme } from '@mui/material';

export const styles = {
  feedbackToggle: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.white,
    fontWeight: 600,
    fontSize: 12,
    '&:hover': {
      backgroundColor: 'unset',
    },
    ml: 8,
    p: 0,
  }),

  feedbackSuccess: (theme: Theme) => ({
    color: theme.colors.success[600],
    ml: 8,
  }),

  feedbackError: (theme: Theme) => ({
    maxWidth: '22rem',
    color: theme.colors.error[900],
    backgroundColor: theme.colors.error[50],
    p: 4,
    mt: 4,
    ml: 8,
    borderRadius: '0 1.25rem 1.25rem 1.25rem',
  }),

  feedbackErrorButton: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.error[50],
    '&:hover': {
      backgroundColor: 'unset',
    },
  }),

  feedbackErrorButtonBox: {
    textAlign: 'center',
  },
};
